/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IEditableFieldProps, ILink } from './editable-field';
import { TextField } from './text-field';

export const LinkField = (props: IEditableFieldProps<ILink>) => {
    const onClick = (event: React.SyntheticEvent) => {
        if (!props.disabled) {
            event.preventDefault();
        }
        if (props.fieldProps.onClick) {
            props.fieldProps.onClick(event);
        }
    };
    return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a
            key={props.fieldProps.key}
            className={props.fieldProps.className}
            role={props.fieldProps.role}
            title={props.fieldProps.title || props.fieldProps.text}
            href={props.fieldProps.href}
            aria-label={props.fieldProps.ariaLabel}
            target={props.fieldProps.openInNewTab ? '_blank' : undefined}
            onClick={onClick}
            {...(props.fieldProps.additionalProperties || {})}
        >
            <TextField
                {...props}
                fieldProps={{
                    text: props.fieldProps.text || '',
                    tag: props.fieldProps.linkTag,
                    className: props.fieldProps.innerClassName
                }}
            />
        </a>
    );
};
